import React from 'react';

import IndexPage from '../components/IndexPage';

const Index = () => <IndexPage lang="en" />;

export default Index;
